import { configureStore } from '@reduxjs/toolkit';
import authReducer from './store/authSlice';
import contestReducer from "./store/contestSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    contest: contestReducer,
  },

});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
